import { useState, useEffect } from 'react';

const STORAGE_KEY = 'kog_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: 'var(--bg-secondary, #1a1a2e)',
        borderTop: '1px solid var(--border-primary, #2a2a3e)',
        padding: '14px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        flexWrap: 'wrap',
      }}
    >
      <span style={{ color: 'var(--text-secondary, #a0a0b0)', fontSize: '13px' }}>
        We use cookies and local storage to improve your experience. By continuing you agree to our use of cookies.
      </span>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          onClick={accept}
          style={{
            background: 'var(--netrun-green, #00ff88)',
            color: 'var(--netrun-black, #0a0a14)',
            border: 'none',
            borderRadius: '6px',
            padding: '6px 16px',
            fontSize: '13px',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Accept
        </button>
        <button
          onClick={decline}
          style={{
            background: 'transparent',
            color: 'var(--text-secondary, #a0a0b0)',
            border: '1px solid var(--border-primary, #2a2a3e)',
            borderRadius: '6px',
            padding: '6px 16px',
            fontSize: '13px',
            cursor: 'pointer',
          }}
        >
          Decline
        </button>
      </div>
    </div>
  );
}
